import { createStore, useStore } from 'zustand';

interface AdditionalAuthorizationStore {
    isAdditionalAuthorizationModalOpen: boolean;
    showAdditionalAuthorizationModal: () => void;
    closeAdditionalAuthorizationModal: () => void;
}

const additionalAuthorizationStore = createStore<AdditionalAuthorizationStore>((set) => ({
    isAdditionalAuthorizationModalOpen: false,
    showAdditionalAuthorizationModal: () => set({ isAdditionalAuthorizationModalOpen: true }),
    closeAdditionalAuthorizationModal: () => set({ isAdditionalAuthorizationModalOpen: false }),
}));

export const { showAdditionalAuthorizationModal, closeAdditionalAuthorizationModal } =
    additionalAuthorizationStore.getState();

export const useAdditionalAuthorizationStore = () => useStore(additionalAuthorizationStore);
